export default "__VITE_ASSET__CAI48fMu__"